import React from 'react';
import {Typography} from "@mui/material";
import AccountBalanceList from "src/components/account/AccountBalanceList";
import {Link} from "react-router-dom";

const BalanceHistoryPage = () => {

  return (
    <>
      <Typography variant="h2" mb={3}>Saldo historie</Typography>

      <Typography variant="body1" mb={3}>
        Hier zie je een overzicht van het saldo dat je met onze testen hebt verdient. Ga naar <Link to="/">dashboard</Link> om een nieuwe uitbetaling aan te vragen.
      </Typography>

      <AccountBalanceList />
    </>
  );
}

export default BalanceHistoryPage;

BalanceHistoryPage.propTypes = {};

BalanceHistoryPage.defaultProps = {};
